import locale from "../../../locale";

export const translateLabel = (type, value) => locale(`${type}.` + value);

export const mapValueToSelectOption = (value, type='role') => ({
    value: value,
    label: translateLabel(type, value),
});

export const getEventRegistrationFields = (event, fields = []) => {
    const defaultFields = fields.length
        ? fields
        : [{name: 'name', type: 'text', required: true, label: 'Имя'}];

    const registrationFields = event.registrationFields.map(({required, order, field}) => ({
        ...field,
        label: field.label_ru,
        placeholder: field.placeholder_ru,
        required,
        order
    })) || [];

    return [...defaultFields, ...registrationFields];
}
